<template>
    <section class="g-container || o-band">
        <div class="o-container">

            <app-intro class="u-d-flex align-items-center justify-content-between">
                <h3 class="u-mb-0">Overeenkomst Addsoft</h3>

                <router-link to="/admin/account" class="c-link">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18.589" height="12.388" viewBox="0 0 18.589 12.388">
                        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2">
                            <path d="M17.589 6.223H4.714"/>
                            <path d="M7.439 10.989L1.001 6.195l6.438-4.8" stroke-linejoin="round"/>
                            <path d="M7.439 10.99L5.894 6.195l1.545-4.8" stroke-linejoin="round"/>
                        </g>
                    </svg>

                    Terug <span class="u-hidden-xsl-down">naar overzicht</span>
                </router-link>
            </app-intro>

            <div class="c-loading" v-if="loading">
                <spinner/>
                Bezig met laden van de vestiging...
            </div>

            <transition-group name="fade" tag="section" v-if="!loading">
                <form v-on:submit.prevent="handleSubmit" class="form form---tint" novalidate key="form">

                    <div class="g-gap:2-xs g-gap:2-sm>sm" :class="{
                        'g-cols:3>md': (location.AkkoordIncassoNodig === 'Nee' && location.AkkoordVerwerkersovereenkomstNodig === 'Nee') || location.AkkoordIncassoNodig === 'Ja' && location.AkkoordVerwerkersovereenkomstNodig === 'Ja',
                        'g-cols:2>md': location.AkkoordIncassoNodig === 'Ja' && location.AkkoordVerwerkersovereenkomstNodig === 'Nee',
                    }">

                        <div class="o-card o-card--small" :class="{ 'g-col:span-3': location.AkkoordIncassoNodig === 'Nee' && location.AkkoordVerwerkersovereenkomstNodig === 'Nee' }">
                            <h4>Voorwaarden</h4>

                            <p class="u-mb-0">Wat is er o.a. veranderd? Het eigendomsrecht van de bestanden/ informatie is nu beter vastgelegd. Aansprakelijkheid van Addsoft ten aanzien van de geleverde diensten. Bewaar termijn 20 jaar. Klik <a href="https://addsoft.nl/voorwaarden" target="_blank">hier</a> om de voorwaarden te bekijken. </p>
                        </div>

                        <div class="o-card o-card--small" v-if="location.AkkoordVerwerkersovereenkomstNodig === 'Ja'">
                            <h4>Verwerkersovereenkomst</h4>

                            <p class="u-mb-0">De verwerkersovereenkomst is weer up-to-date gebracht naar huidige maatstaven en wetgeving. Klik <a href="https://addsoft.nl/verwerkersovereenkomst" target="_blank">hier</a> om de verwerkersovereenkomst te bekijken. </p>
                        </div>

                        <div class="o-card o-card--small" v-if="location.AkkoordIncassoNodig === 'Ja'">
                            <h4>Incasso overeenkomst</h4>

                            <p class="u-mb-0">Omdat dat we gaan incasseren van een andere bankrekening dienen wij gezamenlijk een nieuw incasso overeenkomst met elkaar aan te gaan.</p>
                        </div>

                    </div>

                    <div class="g-gap:1-xs || o-card" v-if="location.AkkoordIncassoNodig === 'Ja'">
                        <h4>Doorlopende machtiging</h4>

                        <div class="g-cols:4/1 || g-gap:1-xs || align-items-center">

                            <div>Naam incassant</div>

                            <div class="form-control-static">Addsoft B.V.</div>

                        </div>

                        <div class="g-cols:4/1 || g-gap:1-xs || align-items-center">

                            <div>Adres</div>

                            <div class="form-control-static">Haarstraat 14</div>

                        </div>

                        <div class="g-cols:4/1 || g-gap:1-xs || align-items-center">

                            <div>Postcode</div>

                            <div class="form-control-static">7642 AP</div>

                            <!--<div class="g-cols:3 || g-gap:1-xs">
                                <div class="form-control-static">7642 AP</div>

                                <div class="g-cols:2/auto || align-items-center">

                                    <div>Plaats</div>

                                    <div class="form-control-static">Rijssen</div>

                                </div>

                                <div class="g-cols:2/auto || align-items-center">

                                    <div>Land</div>

                                    <div class="form-control-static">Nederland</div>

                                </div>

                            </div>-->

                        </div>

                        <div class="g-cols:4/1 || g-gap:1-xs || align-items-center">

                            <div>Plaats</div>

                            <div class="form-control-static">Rijssen</div>

                        </div>

                        <div class="g-cols:4/1 || g-gap:1-xs || align-items-center">

                            <div>Land</div>

                            <div class="form-control-static">Nederland</div>

                        </div>

                        <div class="g-cols:4/1 || g-gap:1-xs || align-items-center">

                            <div>Incassant ID</div>

                            <div class="form-control-static">NL95 RABO 0348 1634 52</div>

                        </div>

                        <div class="g-cols:4/1 || g-gap:1-xs || align-items-center">

                            <div>Kenmerk machtiging</div>

                            <div class="form-control-static">1234566700005</div>

                        </div>

                        <div class="g-cols:4/1 || g-gap:1-xs || align-items-center">

                            <div>Reden betaling</div>

                            <div class="form-control-static">Abonnement \ Diensten Addsoft</div>

                        </div>

                        <hr/>

                        <p v-if="location.AkkoordIncassoNodig === 'Ja'">Door ondertekening van dit formulier geeft u toestemming aan <strong>Addsoft B.V.</strong> om doorlopende incasso-opdrachten te sturen naar uw bank
                            om een bedrag van uw rekening af te schrijven en aan uw bank om doorlopend een bedrag van uw rekening af te schrijven overeenkomstig
                            de opdracht van <strong>Addsoft B.V.</strong> Als u het niet eens bent met deze afschrijving kunt u deze laten terugboeken. Neem hiervoor binnen 8 weken
                            na afschrijving contact op met uw bank. Vraag uw bank naar de voorwaarden.</p>

                        <h4>Gegevens</h4>

                        <div class="g-cols:4/1 || g-gap:1-xs || align-items-center">

                            <div>Bedrijfsnaam</div>

                            <div class="form-control-static">{{ location.Vestigingsnaam }}</div>

                        </div>

                        <div class="g-cols:4/1 || g-gap:1-xs || align-items-center">

                            <div>Naam</div>

                            <div class="form-control-static">{{ location.Contactpersoon }}</div>

                        </div>

                        <div class="g-cols:4/1 || g-gap:1-xs || align-items-center">

                            <div>Adres</div>

                            <div class="form-control-static">{{ location.Vestigingsadres }}</div>

                        </div>

                        <div class="g-cols:4/1 || g-gap:1-xs || align-items-center">

                            <div>Postcode</div>

                            <div class="form-control-static">{{ location.Vestigingspostcode }}</div>

                        </div>

                        <div class="g-cols:4/1 || g-gap:1-xs || align-items-center">

                            <div>Plaats</div>

                            <div class="form-control-static">{{ location.Vestigingsplaats }}</div>

                        </div>

                        <div class="g-cols:4/1 || g-gap:1-xs || align-items-center">

                            <div>Land</div>

                            <div class="form-control-static">{{ location.Vestigingsland }}</div>

                        </div>

                        <div class="g-cols:4/1 || g-gap:1-xs || align-items-center">

                            <div>IBAN</div>

                            <div class="form-control-static">{{ location.IBAN ? location.IBAN : '-' }}</div>

                        </div>
                    </div>

                    <div class="g-gap:2-xs || o-card">
                        <div>
                            <h4 class="u-mb-0">Akkoord</h4>
                            <p class="u-mb-0">Ondergetekende verklaart hierbij in rechte op te mogen treden voor deze vestiging:</p>
                        </div>

                        <div class="g-gap:1-xs">
                            <div class="form-group" :class="{ 'has-error': submitted && $v.form.AddsoftAkkoordNaam.$error, 'has-success': submitted && !$v.form.AddsoftAkkoordNaam.$error }">
                                <label class="u-sr-only" for="register-Naam">Naam</label>
                                <input type="text" v-model="form.AddsoftAkkoordNaam" id="register-Naam" name="AddsoftAkkoordNaam" class="form-control" placeholder="Vul hier je voor- en achternaam in" />
                                <div v-if="submitted && $v.form.AddsoftAkkoordNaam.$error" class="form-validation">
                                    <span v-if="!$v.form.AddsoftAkkoordNaam.required">Naam is verplicht</span>
                                </div>
                            </div>

                            <div class="form-group" :class="{ 'has-error': submitted && $v.form.AddsoftAkkoordDatum.$error, 'has-success': submitted && !$v.form.AddsoftAkkoordDatum.$error }">
                                <label class="u-sr-only" for="register-Datum">Datum</label>
                                <input type="text" v-model="form.AddsoftAkkoordDatum" id="register-Datum" name="AddsoftAkkoordDatum" class="form-control" placeholder="Datum" />
                                <div v-if="submitted && $v.form.AddsoftAkkoordDatum.$error" class="form-validation">
                                    <span v-if="!$v.form.AddsoftAkkoordDatum.required">Datum is verplicht</span>
                                </div>
                            </div>

                            <div class="form-group" :class="{ 'has-error': submitted && $v.form.AddsoftAkkoordPlaats.$error, 'has-success': submitted && !$v.form.AddsoftAkkoordPlaats.$error }">
                                <label class="u-sr-only" for="register-Plaats">Plaats</label>
                                <input type="text" v-model="form.AddsoftAkkoordPlaats" id="register-Plaats" name="AddsoftAkkoordPlaats" class="form-control" placeholder="Plaats" />
                                <div v-if="submitted && $v.form.AddsoftAkkoordPlaats.$error" class="form-validation">
                                    <span v-if="!$v.form.AddsoftAkkoordPlaats.required">Plaats is verplicht</span>
                                </div>
                            </div>
                        </div>

                        <p class="u-mb-0">Door op de knop "Overeenkomst bevestigen" te klikken, ga je akkoord met
                            <span v-if="location.AkkoordVerwerkersovereenkomstNodig === 'Ja'">de <a href="https://addsoft.nl/verwerkersovereenkomst" target="_blank">verwerkersovereenkomst</a>, </span>
                            <span v-if="location.AkkoordIncassoNodig === 'Ja'">de incasso overeenkomst </span>
                            <span>en de <a href="https://addsoft.nl/voorwaarden" target="_blank">voorwaarden</a></span>.
                        </p>
                    </div>

                    <button type="submit" class="[ c-btn c-btn--info ] form-submit-btn" :disabled="status.updating">
                        <span v-show="status.updating"><spinner/></span>
                        <span v-show="!status.updating">Overeenkomst bevestigen</span>
                        <svg v-show="!status.updating" xmlns="http://www.w3.org/2000/svg" width="14.875" height="14.875" viewBox="0 0 14.875 14.875">
                            <g fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2">
                                <path d="M1 7.438h12.875"/>
                                <path d="M7.437 1v12.875"/>
                            </g>
                        </svg>
                    </button>
                </form>
            </transition-group>

        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import { required } from 'vuelidate/lib/validators';
    import AppIntro from '../../components/app/AppIntro.vue';
    import Spinner from '../../components/Spinner.vue';
    import normalizeFormData from '../../helpers/normalizeFormData';
    import { agreementService } from '../../services';

    export default {
        components: {
            Spinner,
            AppIntro,
        },
        data () {
            return {
                loading: true,
                submitted: false,
                location: {},
                form: {
                    AddsoftAkkoordNaam: '',
                    AddsoftAkkoordDatum: `${new Date(Date.now()).toLocaleDateString('nl-NL')} ${new Date(Date.now()).toLocaleTimeString('nl-NL')}`,
                    // AddsoftAkkoordDatum: new Date().toLocaleDateString(),
                    AddsoftAkkoordPlaats: '',
                },
            };
        },
        computed: {
            ...mapState('agreement', ['status']),
        },
        validations: {
            form: {
                AddsoftAkkoordNaam: { required },
                AddsoftAkkoordDatum: {
                    required,
                },
                AddsoftAkkoordPlaats: { required },
            },
        },
        async created () {
            // get the location
            await this.getAgreement();

            // reset loading
            this.loading = false;
        },
        methods: {
            getAgreement () {
                return agreementService
                    .get(this.$route.params.id)
                    .then((result) => {
                        this.location = result;
                    }).catch(() => {
                        this.loading = false;
                    });
            },
            handleSubmit (e) {
                this.submitted = true;

                // validate the form
                this.$v.form.$touch();

                // if its still pending or an error is returned do not submit
                if (this.$v.form.$pending || this.$v.form.$error) return;

                // normalize form data
                const data = normalizeFormData(e.target);

                // get the id
                const id = this.$route.params.id;

                // kick off the update
                this.$store.dispatch('agreement/update', { id, data });
            },
        },

    };
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/_essentials.scss";

    /*.table {
        @include media-breakpoint-only(sm) {
            grid-template-columns: rem(150) 1fr;
            margin: 0;
            max-width: 100%;
        }
    }*/
</style>
